module.exports = __webpack_public_path__ + "static/media/1.4e8b797a.png";


//////////////////
// WEBPACK FOOTER
// ./src/workoutPreview/img/1.png
// module id = 2108
// module chunks = 0